<div style="width: 100%;"><img class="image" src='{{img}}' (click)="onCheck()"></div>